export function isPasswordRecoveryRoute(search: string): boolean {
  return new URLSearchParams(search).get('view') === 'forgot-password';
}

export function isPasswordRecoveryEntryRoute(pathname: string, search: string): boolean {
  return (
    pathname === '/reset-password' || (pathname === '/login' && isPasswordRecoveryRoute(search))
  );
}
